
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { sortBy, tail, isEmpty, tryFind, collect, ofArray, singleton as singleton_1, map, toArray, exists, contains, filter, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { safeHash, comparePrimitives, equals, createObj, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { doRangesOverlap } from "../../Shared/Helper.js";
import { Table_customPropertyColumnDefinitions } from "../../Widgets/CustomProperties.js";
import { SelectToolModal } from "../Modals/SelectToolModal.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { TableControl$1, Table } from "../../Widgets/Table/Table.js";
import { empty as empty_1, toList, singleton, append, delay, toArray as toArray_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { BusinessUnitId__get_unwrap, FormKind as FormKind_1, ConsumableId__get_unwrap, FormState__getValidation } from "../../Shared/Shared.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InvalidTextValue } from "../../Components/Text.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { SelectToolWithQuantityModal } from "../Modals/SelectToolWithQuantityModal.js";
import { AutoSuggestInput, NumberInput } from "../../Components/Input.js";
import { unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { numberInputIntMaxValue } from "../../Common.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { SelectConsumableModal } from "../Modals/SelectConsumableModal.js";
import { SelectSetModal } from "../Modals/SelectSetModal.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName } from "../../Shared/User.js";
import { FormContainer } from "../../Components/FormContainer.js";
import { Msg } from "./Types.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { BusinessUnitSelect } from "../../Widgets/BusinessUnitSelect.js";
import { GroupedSelect } from "../../Components/Select.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextArea } from "../../Components/TextArea.js";
import { FormSection } from "../../Widgets/FormSection.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEdit, update as update_1, initNew } from "./State.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Skeleton } from "../../Components/Skeleton.js";

function ToolTable(props) {
    let Title, TableRows, Options;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(empty());
    const setSelectedToolIds = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const patternInput_3 = reactApi.useState(false);
    const setIsAddToolModalOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsRemoveToolIdDialogOpen = patternInput_4[1];
    const assignedTools = filter((tool) => contains(tool.Id, props.ToolIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), props.Tools);
    const selectableTools = filter((tool_1) => {
        if (!contains(tool_1.Id, props.ToolIds, {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: (x_1) => (stringHash(x_1) | 0),
        })) {
            const matchValue = props.StartDate;
            const matchValue_1 = props.EndDate;
            let matchResult, endDate, startDate;
            if (matchValue != null) {
                if (matchValue_1 != null) {
                    matchResult = 0;
                    endDate = matchValue_1;
                    startDate = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return !exists((r) => doRangesOverlap(startDate, endDate, r.StartDate, r.EndDate), tool_1.Reservations);
                default:
                    return true;
            }
        }
        else {
            return false;
        }
    }, props.Tools);
    const customPropertyColumns = Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (dto) => dto.CustomProperties, t, props.CustomerConfiguration.Currency);
    const xs_2 = [createElement(SelectToolModal, {
        Customer: props.Customer,
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: patternInput_3[0],
        OnAddToolIds: (toolIds) => {
            props.OnAssignToolId(toolIds);
            setIsAddToolModalOpen(false);
        },
        OnClose: () => {
            setIsAddToolModalOpen(false);
        },
        PropertyConfigurations: props.PropertyConfigurations,
        Tools: selectableTools,
    }), createElement(ConfirmationDialog, (Title = t("set.tool_remove_dialog.title"), {
        Description: t("set.tool_remove_dialog.description"),
        IsOpen: patternInput_4[0],
        OnClose: () => {
            setIsRemoveToolIdDialogOpen(false);
            setSelectedToolIds(empty());
        },
        OnConfirm: () => {
            props.OnRemoveToolId(patternInput_1[0]);
            setIsRemoveToolIdDialogOpen(false);
            setSelectedToolIds(empty());
        },
        Title: Title,
    })), createElement(Table, (TableRows = toArray(assignedTools), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: true,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        RowSelection: "multiRow",
        SaveTableConfiguration: true,
    }, {
        ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto_1) => (new CellContent(5, [map((image) => ({
            ImageUrl: image.ImageUrl,
            Position: image.Position,
        }), dto_1.ToolImages)])), "none", "image")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (row) => {
            let elems_1;
            const matchValue_3 = FormState__getValidation(props.FormState, t, concat("tool-", ...row.Id));
            if (matchValue_3 == null) {
                return new CellContent(0, [row.DisplayName]);
            }
            else {
                const validation = matchValue_3;
                return new CellContent(1, [reactElement("div", createObj(singleton_1((elems_1 = [reactElement("div", {
                    className: join(" ", ["mb-4"]),
                    children: reactApi.Children.toArray([row.DisplayName]),
                }), createElement(InvalidTextValue, {
                    TestId: "",
                    Text: t(validation),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))]);
            }
        }, "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_1) => (new CellContent(0, [row_1.InventoryNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_2) => (new CellContent(0, [row_2.Manufacturer])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("tool.model"), (row_3) => (new CellContent(0, [row_3.Model])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_4) => (new CellContent(0, [row_4.SerialNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", t("general.master_data"), t("general.qr_code"), (dto_2) => (new CellContent(0, [dto_2.QRCodeIds])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("location", t("general.master_data"), t("general.location"), (dto_3) => (new CellContent(0, [dto_3.Location])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storage", t("general.master_data"), t("general.storage"), (dto_4) => (new CellContent(0, [dto_4.Storage])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storageSpace", t("general.master_data"), t("tool.storage_space"), (dto_5) => (new CellContent(0, [dto_5.StorageSpace])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("currentLocation", t("general.master_data"), t("tool.assgined_to"), (dto_6) => (new CellContent(0, [t(dto_6.CurrentLocation)])), "text", "text")), delay(() => customPropertyColumns)))))))))))))))))))))))),
        Controls: ofArray([new TableControl$1(t("general.add"), Shipment_Add(), (_arg_3) => {
            setIsAddToolModalOpen(true);
        }, false, false, "add-tool"), new TableControl$1(t("general.remove"), Recycle_Bin_1(), (tools) => {
            setSelectedToolIds(map((tool_2) => tool_2.Id, tools));
            setIsRemoveToolIdDialogOpen(true);
        }, true, false, "")]),
        Options: Options,
        TableKey: "reservation-tool-table",
        TableRows: TableRows,
    })))];
    return react.createElement(react.Fragment, {}, ...xs_2);
}

function ToolWithQuantityTable(props) {
    let Title, TableRows, Options;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(empty());
    const setSelectedToolIds = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const patternInput_3 = reactApi.useState(false);
    const setIsAddToolModalOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsRemoveToolIdDialogOpen = patternInput_4[1];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const customPropertyColumns = Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (row) => row.Tool.CustomProperties, t, props.CustomerConfiguration.Currency);
    const xs = [createElement(SelectToolWithQuantityModal, {
        Customer: props.Customer,
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: patternInput_3[0],
        OnAddTool: (toolIds) => {
            props.OnAssignToolWithQuantityId(toolIds);
            setIsAddToolModalOpen(false);
        },
        OnClose: () => {
            setIsAddToolModalOpen(false);
        },
        PropertyConfigurations: props.PropertyConfigurations,
        ToolsWithQuantity: filter((tool) => !exists((selectedTool) => {
            if (selectedTool.Tool.Id === tool.Id) {
                return selectedTool.Tool.StorageId === tool.StorageId;
            }
            else {
                return false;
            }
        }, props.SelectedToolsWithQuantity), props.ToolsWithQuantity),
    }), createElement(ConfirmationDialog, (Title = t("set.tool_remove_dialog.title"), {
        Description: t("set.tool_remove_dialog.description"),
        IsOpen: patternInput_4[0],
        OnClose: () => {
            setIsRemoveToolIdDialogOpen(false);
            setSelectedToolIds(empty());
        },
        OnConfirm: () => {
            props.OnRemoveToolWithQuantityId(patternInput_1[0]);
            setIsRemoveToolIdDialogOpen(false);
            setSelectedToolIds(empty());
        },
        Title: Title,
    })), createElement(Table, (TableRows = toArray(props.SelectedToolsWithQuantity), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: true,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        RowSelection: "multiRow",
        SaveTableConfiguration: true,
    }, {
        ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto) => (new CellContent(5, [map((image) => ({
            ImageUrl: image.ImageUrl,
            Position: image.Position,
        }), dto.Tool.ToolImages)])), "none", "image")), delay(() => append(singleton(new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_1) => {
            let Value;
            return new CellContent(1, [createElement(NumberInput, (Value = map_1((value_1) => value_1, row_1.Quantity), {
                ComponentState: componentState,
                MaxValue: numberInputIntMaxValue,
                OnChange: (value_2) => {
                    props.OnChangeQuantity([row_1.Tool, value_2]);
                },
                TestId: "",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, concat("tool-with-quantity-", ...row_1.Tool.Id))),
                Value: unwrap(Value),
            }))]);
        }, "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("unit", "", t("general.unit"), (_arg_3) => (new CellContent(0, [t(Helper_unitToTranslationKey("piece"))])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (row_2) => (new CellContent(0, [row_2.Tool.DisplayName])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_3) => (new CellContent(0, [row_3.Tool.InventoryNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_4) => (new CellContent(0, [row_4.Tool.Manufacturer])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("tool.model"), (row_5) => (new CellContent(0, [row_5.Tool.Model])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", t("general.master_data"), t("general.qr_code"), (row_6) => (new CellContent(0, [row_6.Tool.QRCodeIds])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("location", t("general.master_data"), t("general.location"), (row_7) => (new CellContent(0, [row_7.Tool.Location])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storage", t("general.master_data"), t("general.storage"), (row_8) => {
            let Text$;
            const matchValue = FormState__getValidation(props.FormState, t, concat("tool-with-quantity-storage-", ...row_8.Tool.Id));
            return (matchValue == null) ? (new CellContent(0, [row_8.Tool.Storage])) : (new CellContent(1, [createElement(InvalidTextValue, (Text$ = t(matchValue), {
                TestId: concat("tool-with-quantity-storage-", row_8.Tool.Id, ..."-test-id"),
                Text: Text$,
            }))]));
        }, "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storageSpace", t("general.master_data"), t("tool.storage_space"), (row_9) => (new CellContent(0, [row_9.Tool.StorageSpace])), "text", "text")), delay(() => customPropertyColumns)))))))))))))))))))))))),
        Controls: ofArray([new TableControl$1(t("general.add"), Shipment_Add(), (_arg_5) => {
            setIsAddToolModalOpen(true);
        }, false, false, "add-tool"), new TableControl$1(t("general.remove"), Recycle_Bin_1(), (tools) => {
            setSelectedToolIds(map((tool_1) => tool_1.Tool, tools));
            setIsRemoveToolIdDialogOpen(true);
        }, true, false, "")]),
        Options: Options,
        TableKey: "reservation-tool-with-quantity-table",
        TableRows: TableRows,
    })))];
    return react.createElement(react.Fragment, {}, ...xs);
}

function ConsumableTable(props) {
    let Title, TableRows, Options;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(empty());
    const setSelectedConsumableIds = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsAddConsumableModalOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setIsRemoveConsumableIdDialogOpen = patternInput_3[1];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const customPropertyColumns = Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (row) => row.Consumable.CustomProperties, t, props.CustomerConfiguration.Currency);
    const xs = [createElement(SelectConsumableModal, {
        Consumables: filter((tool) => !exists((selectedTool) => {
            if (equals(selectedTool.Consumable.Id, tool.Id)) {
                return selectedTool.Consumable.StorageId === tool.StorageId;
            }
            else {
                return false;
            }
        }, props.SelectedConsumables), props.Consumables),
        Customer: props.Customer,
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: patternInput_2[0],
        OnAddConsumable: (consumableIds) => {
            props.OnAssignConsumableId(consumableIds);
            setIsAddConsumableModalOpen(false);
        },
        OnClose: () => {
            setIsAddConsumableModalOpen(false);
        },
        PropertyConfigurations: props.PropertyConfigurations,
    }), createElement(ConfirmationDialog, (Title = t("set.tool_remove_dialog.title"), {
        Description: t("set.tool_remove_dialog.description"),
        IsOpen: patternInput_3[0],
        OnClose: () => {
            setIsRemoveConsumableIdDialogOpen(false);
            setSelectedConsumableIds(empty());
        },
        OnConfirm: () => {
            props.OnRemoveConsumableId(patternInput_1[0]);
            setIsRemoveConsumableIdDialogOpen(false);
            setSelectedConsumableIds(empty());
        },
        Title: Title,
    })), createElement(Table, (TableRows = toArray(props.SelectedConsumables), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: true,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        RowSelection: "multiRow",
        SaveTableConfiguration: true,
    }, {
        ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto) => (new CellContent(4, [dto.Consumable.ImageUrl])), "none", "image")), delay(() => append(singleton(new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_1) => {
            let Value;
            return new CellContent(1, [createElement(NumberInput, (Value = map_1((value_1) => value_1, row_1.Quantity), {
                ComponentState: componentState,
                OnChange: (value_2) => {
                    props.OnChangeQuantity([row_1.Consumable, value_2]);
                },
                TestId: "",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, concat("consumable-", ...ConsumableId__get_unwrap(row_1.Consumable.Id)))),
                Value: unwrap(Value),
            }))]);
        }, "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("unit", "", t("general.unit"), (row_2) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_2.Consumable.Unit))])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (row_3) => (new CellContent(0, [row_3.Consumable.Name])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_4) => (new CellContent(0, [row_4.Consumable.InventoryNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", t("general.master_data"), t("general.qr_code"), (row_5) => (new CellContent(0, [row_5.Consumable.QRCodeIds])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storage", t("general.master_data"), t("general.storage"), (row_6) => {
            let Text$;
            const matchValue = FormState__getValidation(props.FormState, t, concat("consumable-storage-", ...ConsumableId__get_unwrap(row_6.Consumable.Id)));
            return (matchValue == null) ? (new CellContent(0, [row_6.Consumable.Storage])) : (new CellContent(1, [createElement(InvalidTextValue, (Text$ = t(matchValue), {
                TestId: concat("consumable-storage-", ConsumableId__get_unwrap(row_6.Consumable.Id), ..."-test-id"),
                Text: Text$,
            }))]));
        }, "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storageSpace", t("general.master_data"), t("tool.storage_space"), (row_7) => (new CellContent(0, [row_7.Consumable.StorageSpace])), "text", "text")), delay(() => customPropertyColumns)))))))))))))))))),
        Controls: ofArray([new TableControl$1(t("general.add"), Shipment_Add(), (_arg_4) => {
            setIsAddConsumableModalOpen(true);
        }, false, false, "add-consumable"), new TableControl$1(t("general.remove"), Recycle_Bin_1(), (consumables) => {
            setSelectedConsumableIds(map((consumable) => consumable.Consumable, consumables));
            setIsRemoveConsumableIdDialogOpen(true);
        }, true, false, "")]),
        Options: Options,
        TableKey: "reservation-consumable-table",
        TableRows: TableRows,
    })))];
    return react.createElement(react.Fragment, {}, ...xs);
}

function SetTable(props) {
    let Title, TableRows, Options;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(empty());
    const setSelectedSetIds = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsAddSetModalOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setIsRemoveSetIdDialogOpen = patternInput_3[1];
    const assignedTools = filter((tool) => contains(tool.Id, props.SetIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), props.Sets);
    const selectableSets = filter((set$) => {
        if ((set$.ToolOverviewType === "set") && !contains(set$.Id, props.SetIds, {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: (x_1) => (stringHash(x_1) | 0),
        })) {
            const matchValue = props.StartDate;
            const matchValue_1 = props.EndDate;
            let matchResult, endDate, startDate;
            if (matchValue != null) {
                if (matchValue_1 != null) {
                    matchResult = 0;
                    endDate = matchValue_1;
                    startDate = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return !exists((r) => doRangesOverlap(startDate, endDate, r.StartDate, r.EndDate), set$.Reservations);
                default:
                    return true;
            }
        }
        else {
            return false;
        }
    }, props.Sets);
    const customPropertyColumns = Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (dto) => dto.CustomProperties, t, props.CustomerConfiguration.Currency);
    const xs_2 = [createElement(SelectSetModal, {
        Customer: props.Customer,
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: patternInput_2[0],
        OnAddSetIds: (toolIds) => {
            props.OnAssignSetId(toolIds);
            setIsAddSetModalOpen(false);
        },
        OnClose: () => {
            setIsAddSetModalOpen(false);
        },
        PropertyConfigurations: props.PropertyConfigurations,
        Sets: selectableSets,
    }), createElement(ConfirmationDialog, (Title = t("set.tool_remove_dialog.title"), {
        Description: t("set.tool_remove_dialog.description"),
        IsOpen: patternInput_3[0],
        OnClose: () => {
            setIsRemoveSetIdDialogOpen(false);
            setSelectedSetIds(empty());
        },
        OnConfirm: () => {
            props.OnRemoveSetId(patternInput_1[0]);
            setIsRemoveSetIdDialogOpen(false);
            setSelectedSetIds(empty());
        },
        Title: Title,
    })), createElement(Table, (TableRows = toArray(assignedTools), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: true,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        RowSelection: "multiRow",
        SaveTableConfiguration: true,
    }, {
        ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto_1) => (new CellContent(5, [map((image) => ({
            ImageUrl: image.ImageUrl,
            Position: image.Position,
        }), dto_1.ToolImages)])), "none", "image")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (row) => {
            let elems_1;
            const matchValue_3 = FormState__getValidation(props.FormState, t, concat("set-", ...row.Id));
            if (matchValue_3 == null) {
                return new CellContent(0, [row.DisplayName]);
            }
            else {
                const validation = matchValue_3;
                return new CellContent(1, [reactElement("div", createObj(singleton_1((elems_1 = [reactElement("div", {
                    className: join(" ", ["mb-4"]),
                    children: reactApi.Children.toArray([row.DisplayName]),
                }), createElement(InvalidTextValue, {
                    TestId: "",
                    Text: t(validation),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))]);
            }
        }, "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_1) => (new CellContent(0, [row_1.DisplayName])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_2) => (new CellContent(0, [row_2.Manufacturer])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("tool.model"), (row_3) => (new CellContent(0, [row_3.Model])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_4) => (new CellContent(0, [row_4.SerialNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", t("general.master_data"), t("general.qr_code"), (row_5) => (new CellContent(0, [row_5.QRCodeIds])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("location", t("general.master_data"), t("general.location"), (row_6) => (new CellContent(0, [row_6.Location])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storage", t("general.master_data"), t("general.storage"), (row_7) => (new CellContent(0, [row_7.Storage])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storageSpace", t("general.master_data"), t("tool.storage_space"), (row_8) => (new CellContent(0, [row_8.StorageSpace])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("currentLocation", t("general.master_data"), t("tool.assgined_to"), (row_9) => (new CellContent(0, [t(row_9.CurrentLocation)])), "text", "text")), delay(() => customPropertyColumns)))))))))))))))))))))))),
        Controls: ofArray([new TableControl$1(t("general.add"), Shipment_Add(), (_arg_3) => {
            setIsAddSetModalOpen(true);
        }, false, false, "add-tool"), new TableControl$1(t("general.remove"), Recycle_Bin_1(), (sets) => {
            setSelectedSetIds(map((set$_1) => set$_1.Id, sets));
            setIsRemoveSetIdDialogOpen(true);
        }, true, false, "")]),
        Options: Options,
        TableKey: "reservation-set-table",
        TableRows: TableRows,
    })))];
    return react.createElement(react.Fragment, {}, ...xs_2);
}

function ReservationForm(props) {
    let OnSave;
    const t = useTranslation()[0];
    const toolIdsAssignedToSet = collect((x) => x, map((_arg) => _arg.SetAssignedToolIds, filter((tool) => (tool.ToolOverviewType === "set"), props.Tools)));
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const selectedReceiver = map_1((receiver_1) => {
        const matchValue = receiver_1.LocationName;
        if (matchValue != null) {
            const locationName = matchValue;
            if (equals(receiver_1.ReceiverType, new ReceiverTypeName(4, []))) {
                return {
                    label: concat(locationName, " - ", ...receiver_1.Name),
                    value: receiver_1,
                };
            }
            else {
                return {
                    label: concat(receiver_1.Name, " - ", ...locationName),
                    value: receiver_1,
                };
            }
        }
        else {
            return {
                label: receiver_1.Name,
                value: receiver_1,
            };
        }
    }, tryFind((receiver) => (receiver.Id === props.FormData.ReceiverId), props.Receivers));
    return createElement(FormContainer, (OnSave = (((props.FormData.StartDate == null) ? true : (props.FormData.EndDate == null)) ? undefined : (() => {
        props.Dispatch(new Msg(0, []));
    })), {
        Children: toList(delay(() => {
            let dependencies_1;
            return append(singleton((dependencies_1 = [props.ReservationNameSuggestions, props.FormData.Name, componentState], reactApi.useMemo(() => createElement(AutoSuggestInput, {
                ComponentState: componentState,
                Label: t("general.name"),
                OnChange: (arg) => {
                    props.Dispatch(new Msg(12, [arg]));
                },
                Suggestions: props.ReservationNameSuggestions,
                TestId: "reservation-form-name-test-id",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
                Value: props.FormData.Name,
            }), dependencies_1))), delay(() => {
                let matchValue_1;
                return append((((isFeatureEnabled(new Feature(17, [])) && props.AccountSettings.BusinessUnitsEnabled) && (equals(props.FormKind, new FormKind_1(0, [])) ? true : equals(props.FormKind, new FormKind_1(2, [])))) && ((matchValue_1 = props.CurrentUser.BusinessUnitIds, isEmpty(matchValue_1) ? !isEmpty(props.BusinessUnits) : (!isEmpty(tail(matchValue_1)))))) ? singleton(createElement(BusinessUnitSelect, {
                    BusinessUnits: props.BusinessUnits,
                    FormState: props.FormState,
                    OnChange: (value) => {
                        props.Dispatch(new Msg(16, [value]));
                    },
                    SelectedBusinessUnitId: unwrap(props.FormData.SelectedBusinessUnitId),
                })) : empty_1(), delay(() => append(singleton(createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
                    ComponentState: componentState,
                    IsClearable: false,
                    Key: "assign-receiver-select",
                    Label: t("general.user"),
                    NoOptionsMessage: "select.employee_no_options",
                    OnChange: (value_1) => {
                        if (value_1 == null) {
                        }
                        else {
                            props.Dispatch(new Msg(11, [value_1.value.Id]));
                        }
                    },
                    Options: map((tupledArg) => {
                        const receiverType = tupledArg[0];
                        const receivers_1 = toArray(sortBy((receiver_5) => receiver_5.label.toLowerCase(), map((receiver_4) => {
                            const matchValue_3 = receiver_4.LocationName;
                            if (matchValue_3 != null) {
                                const locationName_1 = matchValue_3;
                                if (equals(receiverType, new ReceiverTypeName(4, []))) {
                                    return {
                                        label: concat(locationName_1, " - ", ...receiver_4.Name),
                                        value: receiver_4,
                                    };
                                }
                                else {
                                    return {
                                        label: concat(receiver_4.Name, " - ", ...locationName_1),
                                        value: receiver_4,
                                    };
                                }
                            }
                            else {
                                return {
                                    label: receiver_4.Name,
                                    value: receiver_4,
                                };
                            }
                        }, tupledArg[1]), {
                            Compare: (x_3, y_2) => (comparePrimitives(x_3, y_2) | 0),
                        }));
                        return {
                            label: Helper_receiverTypeNameTranslation(t, receiverType),
                            options: receivers_1,
                        };
                    }, List_groupBy((receiver_3) => receiver_3.ReceiverType, filter((receiver_2) => {
                        const matchValue_2 = props.FormData.SelectedBusinessUnitId;
                        if (matchValue_2 == null) {
                            return isEmpty(receiver_2.BusinessUnitIds);
                        }
                        else {
                            return contains(matchValue_2, map(BusinessUnitId__get_unwrap, receiver_2.BusinessUnitIds), {
                                Equals: (x_1, y) => (x_1 === y),
                                GetHashCode: (x_1) => (stringHash(x_1) | 0),
                            });
                        }
                    }, props.Receivers), {
                        Equals: equals,
                        GetHashCode: (x_2) => (safeHash(x_2) | 0),
                    })),
                    PlaceholderKey: "select.employee_placeholder",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "receiver")),
                    Value: unwrap(selectedReceiver),
                }))), delay(() => append(singleton(createElement(DatePicker, {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: t("general.start_date"),
                    OnChange: (date) => {
                        props.Dispatch(new Msg(14, [date]));
                    },
                    TestId: "reservation-form-start-date-test-id",
                    Value: unwrap(props.FormData.StartDate),
                })), delay(() => append(singleton(createElement(DatePicker, {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: t("general.end_date"),
                    MinDate: unwrap(props.FormData.StartDate),
                    OnChange: (date_1) => {
                        props.Dispatch(new Msg(15, [date_1]));
                    },
                    TestId: "reservation-form-end-date-test-id",
                    Value: unwrap(props.FormData.EndDate),
                })), delay(() => append(singleton(createElement(TextArea, {
                    ComponentState: componentState,
                    Label: t("general.description"),
                    OnChange: (arg_1) => {
                        props.Dispatch(new Msg(13, [arg_1]));
                    },
                    TestId: "reservation-form-description-test-id",
                    Value: props.FormData.Description,
                })), delay(() => {
                    let Header_1;
                    return append(singleton(createElement(FormSection, (Header_1 = t("general.tool"), {
                        Content: singleton_1(createElement(ToolTable, {
                            Customer: props.UserData.Customer,
                            CustomerConfiguration: props.CustomerConfiguration,
                            EndDate: unwrap(props.FormData.EndDate),
                            FormState: props.FormState,
                            OnAssignToolId: (arg_2) => {
                                props.Dispatch(new Msg(1, [arg_2]));
                            },
                            OnRemoveToolId: (arg_3) => {
                                props.Dispatch(new Msg(2, [arg_3]));
                            },
                            PropertyConfigurations: props.PropertyConfigurations,
                            StartDate: unwrap(props.FormData.StartDate),
                            ToolIds: props.FormData.ToolIds,
                            Tools: filter((tool_3) => equals(tool_3.BusinessUnitId, props.FormData.SelectedBusinessUnitId), filter((tool_2) => !contains(tool_2.Id, toolIdsAssignedToSet, {
                                Equals: (x_4, y_3) => (x_4 === y_3),
                                GetHashCode: (x_4) => (stringHash(x_4) | 0),
                            }), filter((tool_1) => (tool_1.ToolOverviewType === "tool"), props.Tools))),
                            UserData: props.UserData,
                        })),
                        Header: Header_1,
                        Id: "tools",
                    }))), delay(() => {
                        let Header_2;
                        return append(singleton(createElement(FormSection, (Header_2 = t("general.set"), {
                            Content: singleton_1(createElement(SetTable, {
                                Customer: props.UserData.Customer,
                                CustomerConfiguration: props.CustomerConfiguration,
                                EndDate: unwrap(props.FormData.EndDate),
                                FormState: props.FormState,
                                OnAssignSetId: (arg_4) => {
                                    props.Dispatch(new Msg(3, [arg_4]));
                                },
                                OnRemoveSetId: (arg_5) => {
                                    props.Dispatch(new Msg(4, [arg_5]));
                                },
                                PropertyConfigurations: props.PropertyConfigurations,
                                SetIds: props.FormData.SetIds,
                                Sets: filter((tool_4) => equals(tool_4.BusinessUnitId, props.FormData.SelectedBusinessUnitId), props.Tools),
                                StartDate: unwrap(props.FormData.StartDate),
                                UserData: props.UserData,
                            })),
                            Header: Header_2,
                            Id: "sets",
                        }))), delay(() => {
                            let Header_3;
                            return append(singleton(createElement(FormSection, (Header_3 = t("general.tool_with_quantity"), {
                                Content: singleton_1(createElement(ToolWithQuantityTable, {
                                    Customer: props.UserData.Customer,
                                    CustomerConfiguration: props.CustomerConfiguration,
                                    FormState: props.FormState,
                                    OnAssignToolWithQuantityId: (arg_6) => {
                                        props.Dispatch(new Msg(5, [arg_6]));
                                    },
                                    OnChangeQuantity: (arg_8) => {
                                        let tupledArg_1;
                                        props.Dispatch((tupledArg_1 = arg_8, new Msg(7, [tupledArg_1[0], tupledArg_1[1]])));
                                    },
                                    OnRemoveToolWithQuantityId: (arg_7) => {
                                        props.Dispatch(new Msg(6, [arg_7]));
                                    },
                                    PropertyConfigurations: props.PropertyConfigurations,
                                    SelectedToolsWithQuantity: props.FormData.ToolsWithQuantity,
                                    ToolsWithQuantity: filter((tool_6) => equals(tool_6.BusinessUnitId, props.FormData.SelectedBusinessUnitId), filter((tool_5) => (tool_5.ToolOverviewType === "toolWithQuantity"), props.Tools)),
                                    UserData: props.UserData,
                                })),
                                Header: Header_3,
                                Id: "tool-with-quantity",
                            }))), delay(() => {
                                let Header_4;
                                return append(singleton(createElement(FormSection, (Header_4 = t("general.consumable"), {
                                    Content: singleton_1(createElement(ConsumableTable, {
                                        Consumables: filter((tool_7) => equals(tool_7.BusinessUnitId, props.FormData.SelectedBusinessUnitId), props.Consumables),
                                        Customer: props.UserData.Customer,
                                        CustomerConfiguration: props.CustomerConfiguration,
                                        FormState: props.FormState,
                                        OnAssignConsumableId: (arg_9) => {
                                            props.Dispatch(new Msg(8, [arg_9]));
                                        },
                                        OnChangeQuantity: (arg_11) => {
                                            let tupledArg_2;
                                            props.Dispatch((tupledArg_2 = arg_11, new Msg(10, [tupledArg_2[0], tupledArg_2[1]])));
                                        },
                                        OnRemoveConsumableId: (arg_10) => {
                                            props.Dispatch(new Msg(9, [arg_10]));
                                        },
                                        PropertyConfigurations: props.PropertyConfigurations,
                                        SelectedConsumables: props.FormData.Consumables,
                                        UserData: props.UserData,
                                    })),
                                    Header: Header_4,
                                    Id: "consumables",
                                }))), delay(() => {
                                    const matchValue_4 = FormState__getValidation(props.FormState, t, "global");
                                    if (matchValue_4 == null) {
                                        return empty_1();
                                    }
                                    else {
                                        return singleton(createElement(ErrorAlert, {
                                            Label: matchValue_4,
                                        }));
                                    }
                                }));
                            }));
                        }));
                    }));
                }))))))))));
            }));
        })),
        Header: "",
        OnBack: props.OnBack,
        OnSave: unwrap(OnSave),
    }));
}

export function NewReservationForm(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initNew(tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3]), update_1, (_arg, _arg_1) => {
    }), [props.UserData, props.User, props.ReservationId, props.AccountSettings], undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Tools;
    const matchValue_1 = state_1.Consumables;
    const matchValue_2 = state_1.ReservationNameSuggestions;
    const matchValue_3 = state_1.Receivers;
    const matchValue_4 = state_1.CustomerConfiguration;
    const matchValue_5 = state_1.PropertyConfigurations;
    const matchValue_6 = state_1.BusinessUnits;
    let matchResult, businessUnits, consumables, customerConfiguration, propertyConfigurations, receivers, reservationNameSuggestions, tools;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        businessUnits = matchValue_6.fields[0];
        consumables = matchValue_1.fields[0];
        customerConfiguration = matchValue_4.fields[0];
        propertyConfigurations = matchValue_5.fields[0];
        receivers = matchValue_3.fields[0];
        reservationNameSuggestions = matchValue_2.fields[0];
        tools = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ReservationForm, {
                AccountSettings: state_1.AccountSettings,
                BusinessUnits: businessUnits,
                Consumables: consumables,
                CurrentUser: props.User,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                FormData: state_1.FormData,
                FormKind: state_1.FormKind,
                FormState: state_1.FormState,
                OnBack: () => {
                    RouterModule_nav(ofArray(["reservations"]), 1, 1);
                },
                PropertyConfigurations: propertyConfigurations,
                Receivers: receivers,
                ReservationNameSuggestions: reservationNameSuggestions,
                Tools: tools,
                UserData: props.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function EditReservationForm(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initEdit(tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3]), update_1, (_arg, _arg_1) => {
    }), [props.UserData, props.ReservationId, props.User, props.AccountSettings], undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Tools;
    const matchValue_1 = state_1.Consumables;
    const matchValue_2 = state_1.ReservationNameSuggestions;
    const matchValue_3 = state_1.Receivers;
    const matchValue_4 = state_1.CustomerConfiguration;
    const matchValue_6 = state_1.PropertyConfigurations;
    const matchValue_7 = state_1.BusinessUnits;
    let matchResult, businessUnits, consumables, customerConfiguration, propertyConfigurations, receivers, reservationNameSuggestions, tools;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (state_1.FormData.ReservationDetailDto == null) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        businessUnits = matchValue_7.fields[0];
        consumables = matchValue_1.fields[0];
        customerConfiguration = matchValue_4.fields[0];
        propertyConfigurations = matchValue_6.fields[0];
        receivers = matchValue_3.fields[0];
        reservationNameSuggestions = matchValue_2.fields[0];
        tools = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ReservationForm, {
                AccountSettings: state_1.AccountSettings,
                BusinessUnits: businessUnits,
                Consumables: consumables,
                CurrentUser: props.User,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                FormData: state_1.FormData,
                FormKind: new FormKind_1(1, []),
                FormState: state_1.FormState,
                OnBack: () => {
                    let copyOfStruct;
                    RouterModule_nav(ofArray(["reservations", (copyOfStruct = props.ReservationId, copyOfStruct)]), 1, 1);
                },
                PropertyConfigurations: propertyConfigurations,
                Receivers: receivers,
                ReservationNameSuggestions: reservationNameSuggestions,
                Tools: tools,
                UserData: props.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

